"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
class EmailVerificationProvider extends DataProvider_1.default {
    find({ userId }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.query({
                query: graphql_tag_1.default `
        query EmailVerificationFind($userId: [ID]!) {
          emailVerificationFind(userId: $userId)
        }
      `,
                variables: { userId },
            });
            return response.data.emailVerificationFind;
        });
    }
    verify({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.mutate({
                mutation: graphql_tag_1.default `
        mutation EmailVerificationVerify($data: InputEmailVerificationVerify!) {
          emailVerificationVerify(data: $data)
        }
      `,
                variables: { data },
            });
            return response.data.emailVerificationVerify;
        });
    }
    start({ userId }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.mutate({
                mutation: graphql_tag_1.default `
        mutation EmailVerificationStart($userId: ID!) {
          emailVerificationStart(userId: $userId)
        }
      `,
                variables: { userId },
            });
            return response.data.emailVerificationStart;
        });
    }
    verifyByLongCode({ code }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate("emailVerificationVerifyByLongCode", { code });
        });
    }
    setVerified({ userId }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate("emailVerificationSetVerified", { userId });
        });
    }
}
exports.EmailVerificationProvider = EmailVerificationProvider;
//# sourceMappingURL=EmailVerificationProvider.js.map